import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
import { isInteger } from 'lodash';
import moment from 'moment';
/**
 * WordPress dependencies
 */

import { Component } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import Button from '../button';
/**
 * Module Constants
 */

var TIMEZONELESS_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

var TimePicker =
/*#__PURE__*/
function (_Component) {
  _inherits(TimePicker, _Component);

  function TimePicker() {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePicker).apply(this, arguments));
    _this.state = {
      day: '',
      month: '',
      year: '',
      hours: '',
      minutes: '',
      am: true,
      date: null
    };
    _this.changeDate = _this.changeDate.bind(_assertThisInitialized(_this));
    _this.updateMonth = _this.updateMonth.bind(_assertThisInitialized(_this));
    _this.onChangeMonth = _this.onChangeMonth.bind(_assertThisInitialized(_this));
    _this.updateDay = _this.updateDay.bind(_assertThisInitialized(_this));
    _this.onChangeDay = _this.onChangeDay.bind(_assertThisInitialized(_this));
    _this.updateYear = _this.updateYear.bind(_assertThisInitialized(_this));
    _this.onChangeYear = _this.onChangeYear.bind(_assertThisInitialized(_this));
    _this.updateHours = _this.updateHours.bind(_assertThisInitialized(_this));
    _this.updateMinutes = _this.updateMinutes.bind(_assertThisInitialized(_this));
    _this.onChangeHours = _this.onChangeHours.bind(_assertThisInitialized(_this));
    _this.onChangeMinutes = _this.onChangeMinutes.bind(_assertThisInitialized(_this));
    _this.renderMonth = _this.renderMonth.bind(_assertThisInitialized(_this));
    _this.renderDay = _this.renderDay.bind(_assertThisInitialized(_this));
    _this.renderDayMonthFormat = _this.renderDayMonthFormat.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TimePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncState(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          currentTime = _this$props.currentTime,
          is12Hour = _this$props.is12Hour;

      if (currentTime !== prevProps.currentTime || is12Hour !== prevProps.is12Hour) {
        this.syncState(this.props);
      }
    }
    /**
     * Function that sets the date state and calls the onChange with a new date.
     * The date is truncated at the minutes.
     *
     * @param {Object} newDate The date object.
     */

  }, {
    key: "changeDate",
    value: function changeDate(newDate) {
      var dateWithStartOfMinutes = newDate.clone().startOf('minute');
      this.setState({
        date: dateWithStartOfMinutes
      });
      this.props.onChange(newDate.format(TIMEZONELESS_FORMAT));
    }
  }, {
    key: "getMaxHours",
    value: function getMaxHours() {
      return this.props.is12Hour ? 12 : 23;
    }
  }, {
    key: "getMinHours",
    value: function getMinHours() {
      return this.props.is12Hour ? 1 : 0;
    }
  }, {
    key: "syncState",
    value: function syncState(_ref) {
      var currentTime = _ref.currentTime,
          is12Hour = _ref.is12Hour;
      var selected = currentTime ? moment(currentTime) : moment();
      var day = selected.format('DD');
      var month = selected.format('MM');
      var year = selected.format('YYYY');
      var minutes = selected.format('mm');
      var am = selected.format('A');
      var hours = selected.format(is12Hour ? 'hh' : 'HH');
      var date = currentTime ? moment(currentTime) : moment();
      this.setState({
        day: day,
        month: month,
        year: year,
        minutes: minutes,
        hours: hours,
        am: am,
        date: date
      });
    }
  }, {
    key: "updateHours",
    value: function updateHours() {
      var is12Hour = this.props.is12Hour;
      var _this$state = this.state,
          am = _this$state.am,
          hours = _this$state.hours,
          date = _this$state.date;
      var value = parseInt(hours, 10);

      if (!isInteger(value) || is12Hour && (value < 1 || value > 12) || !is12Hour && (value < 0 || value > 23)) {
        this.syncState(this.props);
        return;
      }

      var newDate = is12Hour ? date.clone().hours(am === 'AM' ? value % 12 : (value % 12 + 12) % 24) : date.clone().hours(value);
      this.changeDate(newDate);
    }
  }, {
    key: "updateMinutes",
    value: function updateMinutes() {
      var _this$state2 = this.state,
          minutes = _this$state2.minutes,
          date = _this$state2.date;
      var value = parseInt(minutes, 10);

      if (!isInteger(value) || value < 0 || value > 59) {
        this.syncState(this.props);
        return;
      }

      var newDate = date.clone().minutes(value);
      this.changeDate(newDate);
    }
  }, {
    key: "updateDay",
    value: function updateDay() {
      var _this$state3 = this.state,
          day = _this$state3.day,
          date = _this$state3.date;
      var value = parseInt(day, 10);

      if (!isInteger(value) || value < 1 || value > 31) {
        this.syncState(this.props);
        return;
      }

      var newDate = date.clone().date(value);
      this.changeDate(newDate);
    }
  }, {
    key: "updateMonth",
    value: function updateMonth() {
      var _this$state4 = this.state,
          month = _this$state4.month,
          date = _this$state4.date;
      var value = parseInt(month, 10);

      if (!isInteger(value) || value < 1 || value > 12) {
        this.syncState(this.props);
        return;
      }

      var newDate = date.clone().month(value - 1);
      this.changeDate(newDate);
    }
  }, {
    key: "updateYear",
    value: function updateYear() {
      var _this$state5 = this.state,
          year = _this$state5.year,
          date = _this$state5.date;
      var value = parseInt(year, 10);

      if (!isInteger(value) || value < 0 || value > 9999) {
        this.syncState(this.props);
        return;
      }

      var newDate = date.clone().year(value);
      this.changeDate(newDate);
    }
  }, {
    key: "updateAmPm",
    value: function updateAmPm(value) {
      var _this2 = this;

      return function () {
        var _this2$state = _this2.state,
            am = _this2$state.am,
            date = _this2$state.date,
            hours = _this2$state.hours;

        if (am === value) {
          return;
        }

        var newDate;

        if (value === 'PM') {
          newDate = date.clone().hours((parseInt(hours, 10) % 12 + 12) % 24);
        } else {
          newDate = date.clone().hours(parseInt(hours, 10) % 12);
        }

        _this2.changeDate(newDate);
      };
    }
  }, {
    key: "onChangeDay",
    value: function onChangeDay(event) {
      this.setState({
        day: event.target.value
      });
    }
  }, {
    key: "onChangeMonth",
    value: function onChangeMonth(event) {
      this.setState({
        month: event.target.value
      });
    }
  }, {
    key: "onChangeYear",
    value: function onChangeYear(event) {
      this.setState({
        year: event.target.value
      });
    }
  }, {
    key: "onChangeHours",
    value: function onChangeHours(event) {
      this.setState({
        hours: event.target.value
      });
    }
  }, {
    key: "onChangeMinutes",
    value: function onChangeMinutes(event) {
      var minutes = event.target.value;
      this.setState({
        minutes: minutes === '' ? '' : ('0' + minutes).slice(-2)
      });
    }
  }, {
    key: "renderMonth",
    value: function renderMonth(month) {
      return createElement("div", {
        key: "render-month",
        className: "components-datetime__time-field components-datetime__time-field-month"
      }, createElement("select", {
        "aria-label": __('Month'),
        className: "components-datetime__time-field-month-select",
        value: month,
        onChange: this.onChangeMonth,
        onBlur: this.updateMonth
      }, createElement("option", {
        value: "01"
      }, __('January')), createElement("option", {
        value: "02"
      }, __('February')), createElement("option", {
        value: "03"
      }, __('March')), createElement("option", {
        value: "04"
      }, __('April')), createElement("option", {
        value: "05"
      }, __('May')), createElement("option", {
        value: "06"
      }, __('June')), createElement("option", {
        value: "07"
      }, __('July')), createElement("option", {
        value: "08"
      }, __('August')), createElement("option", {
        value: "09"
      }, __('September')), createElement("option", {
        value: "10"
      }, __('October')), createElement("option", {
        value: "11"
      }, __('November')), createElement("option", {
        value: "12"
      }, __('December'))));
    }
  }, {
    key: "renderDay",
    value: function renderDay(day) {
      return createElement("div", {
        key: "render-day",
        className: "components-datetime__time-field components-datetime__time-field-day"
      }, createElement("input", {
        "aria-label": __('Day'),
        className: "components-datetime__time-field-day-input",
        type: "number",
        value: day,
        step: 1,
        min: 1,
        onChange: this.onChangeDay,
        onBlur: this.updateDay
      }));
    }
  }, {
    key: "renderDayMonthFormat",
    value: function renderDayMonthFormat(is12Hour) {
      var _this$state6 = this.state,
          day = _this$state6.day,
          month = _this$state6.month;
      var layout = [this.renderDay(day), this.renderMonth(month)];
      return is12Hour ? layout : layout.reverse();
    }
  }, {
    key: "render",
    value: function render() {
      var is12Hour = this.props.is12Hour;
      var _this$state7 = this.state,
          year = _this$state7.year,
          minutes = _this$state7.minutes,
          hours = _this$state7.hours,
          am = _this$state7.am;
      return createElement("div", {
        className: classnames('components-datetime__time')
      }, createElement("fieldset", null, createElement("legend", {
        className: "components-datetime__time-legend invisible"
      }, __('Date')), createElement("div", {
        className: "components-datetime__time-wrapper"
      }, this.renderDayMonthFormat(is12Hour), createElement("div", {
        className: "components-datetime__time-field components-datetime__time-field-year"
      }, createElement("input", {
        "aria-label": __('Year'),
        className: "components-datetime__time-field-year-input",
        type: "number",
        step: 1,
        value: year,
        onChange: this.onChangeYear,
        onBlur: this.updateYear
      })))), createElement("fieldset", null, createElement("legend", {
        className: "components-datetime__time-legend invisible"
      }, __('Time')), createElement("div", {
        className: "components-datetime__time-wrapper"
      }, createElement("div", {
        className: "components-datetime__time-field components-datetime__time-field-time"
      }, createElement("input", {
        "aria-label": __('Hours'),
        className: "components-datetime__time-field-hours-input",
        type: "number",
        step: 1,
        min: this.getMinHours(),
        max: this.getMaxHours(),
        value: hours,
        onChange: this.onChangeHours,
        onBlur: this.updateHours
      }), createElement("span", {
        className: "components-datetime__time-separator",
        "aria-hidden": "true"
      }, ":"), createElement("input", {
        "aria-label": __('Minutes'),
        className: "components-datetime__time-field-minutes-input",
        type: "number",
        min: 0,
        max: 59,
        value: minutes,
        onChange: this.onChangeMinutes,
        onBlur: this.updateMinutes
      })), is12Hour && createElement("div", {
        className: "components-datetime__time-field components-datetime__time-field-am-pm"
      }, createElement(Button, {
        "aria-pressed": am === 'AM',
        isDefault: true,
        className: "components-datetime__time-am-button",
        isToggled: am === 'AM',
        onClick: this.updateAmPm('AM')
      }, __('AM')), createElement(Button, {
        "aria-pressed": am === 'PM',
        isDefault: true,
        className: "components-datetime__time-pm-button",
        isToggled: am === 'PM',
        onClick: this.updateAmPm('PM')
      }, __('PM'))))));
    }
  }]);

  return TimePicker;
}(Component);

export default TimePicker;
//# sourceMappingURL=time.js.map